import { Popover as P } from 'radix-ui';
import type { ComponentProps } from 'react';
import { cn } from '@/lib/utils';
import { overlaySurface } from './menu';

export const Popover = P.Root;
export const PopoverTrigger = P.Trigger;
export const PopoverClose = P.Close;

export function PopoverContent({ className, ...props }: ComponentProps<typeof P.Content>) {
  return (
    <P.Portal>
      <P.Content
        sideOffset={8}
        collisionPadding={12}
        className={cn(overlaySurface, 'p-4 focus:outline-none', className)}
        {...props}
      />
    </P.Portal>
  );
}
